import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  ActiveInactiveBank,
  createBank,
  deleteBank,
  getAllActiveBanks,
  getAllBanks,
  getBankByID,
  updateBank,
} from "./services/bank.services";
import { IBank, IBankState } from "./bankModel";

const initialState: IBankState = {
  loading: false,
  formLoading: false,
  error: "",
  BankID: null,
  BankList: [],
  BankDetail: {
    BankName: "",
    IsActive: 1,
  },
};

const bankSlice = createSlice({
  name: "bank",
  initialState,
  reducers: {
    clearBankDetails: (state) => {
      state.BankDetail = initialState.BankDetail;
    },
    setBankID: (state, action) => {
      state.BankID = action.payload;
    },
    clearBankID: (state) => {
      state.BankID = initialState.BankID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllBanks.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllBanks.fulfilled,
      (state, action: PayloadAction<IBank[]>) => {
        state.loading = false;
        state.BankList = action.payload || [];
      }
    );
    builder.addCase(getAllBanks.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.BankList = [];
    });
    builder.addCase(createBank.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(createBank.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createBank.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateBank.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updateBank.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateBank.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteBank.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteBank.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteBank.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getBankByID.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getBankByID.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.BankDetail = action.payload;
    });
    builder.addCase(getBankByID.rejected, (state, action) => {
      state.formLoading = false;
      state.BankDetail = initialState.BankDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveBanks.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveBanks.fulfilled,
      (state, action: PayloadAction<IBank[]>) => {
        state.loading = false;
        state.BankList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveBanks.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.BankList = [];
    });
    builder.addCase(ActiveInactiveBank.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveBank.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveBank.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearBankDetails, clearBankID, setBankID } =
  bankSlice.actions;
export default bankSlice.reducer;
